import httpClient from "./httpClient";

const objectTypesGet = lang => httpClient.get(`/typesOfObjects/${lang}`);

const objectTypesCreate = (lang, data) =>
  httpClient.post(`/typesOfObjects/${lang}`, data);

const objectTypesUpdate = (id, lang, data) =>
  httpClient.put(`/typesOfObjects/${id}/${lang}`, data);

export { objectTypesGet, objectTypesCreate, objectTypesUpdate };
